<template>
  <div class="our-team">
    <div class="container-fluid container-lg">
      <div class="row">
        <div class="col-12 text-start">
          <span class="core-txt">/ Our Experts</span>
        </div>
      </div>
      <div class="row principle-row text-start">
        <div class="col-12 col-sm-6">
          <h2>Talent that's here to help.</h2>
        </div>
        <div class="col-12 col-sm-6 text-sm-end">
          <router-link class="button quote-btn" to="/contact">
            Contact Us ->
          </router-link>
        </div>
        <div class="col-12">
          <p>
            Meet the creative minds and tech-savvy experts behind the pixels,
            dedicated to turning your digital dreams into stunning realities.
          </p>
        </div>
      </div>
      <div class="row expert-row">
        <div
          class="col-12 col-md-6 col-lg-4 mb-4"
          v-for="(member, index) in teamMembers"
          :key="index"
        >
          <div class="card">
            <div class="row">
              <div class="col-6">
                <img :src="member.image" class="card-img-top" alt="" />
              </div>
              <div class="col-6">
                <div class="position-area">
                  <span class="position-txt">{{ member.position }}</span>
                </div>
              </div>
            </div>
            <div class="card-body">
              <h5 class="card-title text-start">{{ member.name }}</h5>
              <p class="card-text text-start">
                {{ member.description }}
              </p>
              <div
                class="social-links-div text-start"
                v-if="member.socialLinks"
              >
                <a class="social-link" href="">
                  <font-awesome-icon :icon="['fab', 'twitter']" />
                </a>
                <a class="social-link" href="">
                  <font-awesome-icon :icon="['fab', 'instagram']" />
                </a>
                <a
                  class="social-link"
                  href="https://www.linkedin.com/in/abdullah-mehboob/"
                >
                  <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurTeam",
  data() {
    return {
      teamMembers: [
        {
          image: require("@/assets/images/team/abdullah.webp"),
          position: "Founder",
          name: "Abdullah Mehboob",
          description:
            "Our inspirational leader who is leading the path towards digital excellence.",
          socialLinks: true,
        },
        {
          image: require("@/assets/images/team/hamid.webp"),
          position: "Manager",
          name: "Hamid Tariq",
          description:
            "Effectively organizing our team to achieve outstanding outcomes.",
          socialLinks: false,
        },
        {
          image: require("@/assets/images/team/waheed.webp"),
          position: "Lead Developer",
          name: "Abdul Waheed",
          description:
            "Mastermind behind innovative and advanced web solutions.",
          socialLinks: false,
        },
        {
          image: require("@/assets/images/team/waleed.webp"),
          position: "Developer",
          name: "Waleed Tayyab",
          description:
            "Turning your ideas into functional and responsive websites.",
          socialLinks: false,
        },
        {
          image: require("@/assets/images/team/umer.webp"),
          position: "Graphic Designer",
          name: "Muhammad Umer",
          description: "Bringing imagination to reality with engaging visuals.",
          socialLinks: false,
        },
        {
          image: require("@/assets/images/team/ahmed.webp"),
          position: "Content Writer",
          name: "Ahmed Saeed",
          description:
            "Specialize in crafting engaging stories for your brand.",
          socialLinks: false,
        },
      ],
    };
  },
  components: {},
};
</script>

<style scoped>
.core-txt {
  font-size: 16px;
  font-weight: 400;
}

.principle-row h2 {
  font-size: 35px;
  font-weight: 600;
  margin-top: 20px;
}

.principle-row p {
  font-size: 18px;
  font-weight: 400;
  margin-top: 30px;
  line-height: 30px;
}

.quote-btn {
  display: inline-block;
  transition: transform 0.4s ease-in-out, background-color 0.4s ease-in-out;
  padding: 10px 50px;
  border: none;
  color: white;
  background-color: var(--primary-color);
  text-decoration: none;
}

.quote-btn:hover {
  transform: scale(0.85);
  background-color: #224486;
}

.expert-row {
  margin-top: 20px;
}

.expert-row img {
  width: 110px;
  height: 110px;
  border-radius: 50%;
}

.expert-row .card {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);
  padding: 40px;
  width: 100%;
  height: 100%;
}

.position-area {
  background-color: #f2f2f2;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 400;
  width: 110px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.position-txt {
  line-height: 15px;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--primary-color);
}

.card-text {
  font-size: 16px;
  font-weight: 500;
  color: rgb(103, 103, 103);
}

.social-links-div {
  margin-top: 20px;
}

.social-link {
  color: black;
  background-color: #f2f2f2;
  margin-right: 10px;
  padding: 8px;
  border-radius: 50%;
}

.social-link:hover {
  color: white;
  background-color: var(--primary-color);
}

@media only screen and (max-width: 991px) {
  .our-team {
    padding-right: 20px;
    padding-left: 20px;
  }
}

@media only screen and (max-width: 575px) {
  .principle-row h2 {
    font-size: 30px;
    font-weight: 700;
  }
}
</style>
